import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

import { CompanyUserService } from '../../../../panel/companies/company-users/services/company-user.service';
import { ModalBaseComponent } from '../../../layout/modal/modal-base-component';
import { User } from '../../../../auth/user';

@Component({
  selector: 'app-deactivate-user',
  templateUrl: './deactivate-user.component.html',
})
export class DeactivateUserComponent extends ModalBaseComponent<User> implements OnInit {
  @Input() public users: User[] = [];
  public companyId: number;
  public subscription: Subscription;

  @Input()
  public selectedUsers: User[] = [];

  @Input()
  public searchable: boolean = true;
  @Input() public subtitle: string = 'PANEL.USERS.DESACTIVER.SUBTITLE';
  @Input() public successLabel: string = 'PANEL.USERS.DESACTIVER.SUCCESS';

  constructor(
    bsModalRef: BsModalRef,
    private companyUserService: CompanyUserService,
    private toasterService: ToastrService,
    private readonly translate: TranslateService
  ) {
    super(bsModalRef);
  }

  public ngOnInit(): void {
    this.users = this.filteredUsers();
    this.selectedUsers = this.selectedUsers.filter(su => !su.deleted);
  }

  private filteredUsers(): User[] {
    return this.users.filter(u => !u.deleted && !this.selectedUsers.some(su => su.id === u.id));
  }

  public isInSelectedInit(email: string) {
    return this.users.some(u => u.email === email);
  }

  public customSearchUser(search: string, user: User) {
    return ['firstname', 'lastname', 'email'].some(k => user[k]?.toLowerCase().indexOf(search.toLowerCase()) > -1);
  }

  public deactivateUsers(): void {
    const updatedUsers = this.selectedUsers.map(u => ({ ...u, deleted: true } as User));
    this.subscription = this.companyUserService.bulk(updatedUsers, this.companyId).subscribe(() => {
      this.toasterService.success(this.translate.instant(this.successLabel, { length: this.selectedUsers.length }));
      this.close();
    });
  }
}
